module.exports = __webpack_public_path__ + "static/img/7_bc_tssi-i.2c4a292.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/7_bc_tssi-i.png
// module id = R7w2
// module chunks = 0